<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-dms__device">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.ymd" placeholder="年月" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.status" placeholder="状态" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="$hasPermission('dms:deviceStorageApp:save')" type="primary" @click="addOrUpdateHandle()">{{
                        $t('add') }}
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <el-table-column prop="ymd" label="年月" header-align="center" align="center"></el-table-column>
                <el-table-column prop="addAmount" label="新增金额(元)" header-align="center" align="center"></el-table-column>
                <el-table-column prop="addFilesize" label="新增存储大小(G)" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="status" label="状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status===0" size="small" type="success">草稿</el-tag>
                        <el-tag v-if="scope.row.status===1" size="small" type="success">生效</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="optStatus" label="操作状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.optStatus===-1" size="small" type="success">待生成任务</el-tag>
                        <el-tag v-if="scope.row.optStatus===0" size="small" type="success">待执行</el-tag>
                        <el-tag v-if="scope.row.optStatus===1" size="small" type="success">下发通知成功</el-tag>
                        <el-tag v-if="scope.row.optStatus===2" size="small" type="success">数据操作成功</el-tag>
                        <el-tag v-if="scope.row.optStatus===3" size="small" type="success">数据写入不完整</el-tag>
                        <el-tag v-if="scope.row.optStatus===4" size="small" type="success">执行失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDate" label="创建者" header-align="center" align="center"></el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('dms:deviceStorageApp:update') && scope.row.status===0" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
                        <el-button v-if="$hasPermission('dms:deviceStorageApp:delete') && (( scope.row.status===0) || (scope.row.status===1  && scope.row.optStatus<=0 ) )" type="text" size="small"
                                   @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
                        </el-button>
                        <el-button v-if="$hasPermission('dms:deviceStorageApp:delete') && scope.row.status===0" type="text" size="small"
                                   @click="publicStatus(scope.row.id)">发布
                        </el-button>
                        <el-button v-if="$hasPermission('dms:deviceStorageApp:update') && scope.row.status===1 && scope.row.optStatus>=0" type="text" size="small"
                                   @click="lookTaskHandle(scope.row.id)">查看文件派发任务
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <!-- 弹窗, 新增 / 修改 -->
            <LookTaskHandle v-if="lookTaskHandleVisible" ref="LookTaskHandle""></LookTaskHandle>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './deviceStorageApp-add-or-update'
    import LookTaskHandle from './deviceStorage-tasklist'
    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/dms/deviceStorageApp/page',
                    getDataListIsPage: true,
                    exportURL: '/dms/deviceStorageApp/export',
                    deleteURL: '/dms/deviceStorageApp',
                    deleteIsBatch: true
                },
                lookTaskHandleVisible:false,
                dataForm: {
                    ymd: '',
                    status: ''
                },
                queryForm:{
                    id:''
                }
            }
        },
        methods: {
            publicStatus(id) {
                this.$confirm('是否确定发布?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.queryForm.id=id
                    this.$http['post']('/dms/deviceStorageApp/publish',this.queryForm).then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.getDataList()
                                //this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {})
                });
            },
            lookTaskHandle(id) {
                this.lookTaskHandleVisible = true
                this.$nextTick(() => {
                    this.$refs.LookTaskHandle.init(id)
                })
            }
        },
        components: {
            AddOrUpdate,
            LookTaskHandle
        }
    }
</script>
